import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles({
    description: {
        margin: '32px 0 12px 0',
    }
});
